<template>
  <div>
    <div id="wrapper" class="wrapper haslayout">
      <WebPortalHeader />
      <!--************************************
                    Main Start
            *************************************-->
      <main id="bg-main" class="bg-main Notice_mainsec">
        <!--************************************
                    DGME links Start
                *************************************-->
        <section class="haslayout st-shape-wrap">
          <div class="container-fluid">
            <div class="row">
              <div class="webportal-contant">
                <LeftSlider />
                <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6">
                  <div class="row">
                    <div class="mid_contant">
                      <div class="col-xs-12 col-12 col-sm-12 col-md-12 col-lg-12 mt-5">
                        <div class="row" id="blog-board" style="padding: 15px;">
                          <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                            <figure class="newsdetailimg">
                              <img
                                :src="`${getBlogUrl}/${getBlogDataById.cover_image}`"
                                alt="image description"
                                
                              />
                              <figcaption class="authors">
                                <img
                                  v-if="
                                    this.loggedInData.user && this.loggedInData.user.profile_image != null
                                  "
                                  class="style-scope yt-img-shadow"
                                  height="40"
                                  width="40"
                                  alt="image"
                                  :src="`${getBlogUrl}/${this.loggedInData.user.profile_image}`"
                                />
                                <img
                                  v-if="
                                    this.loggedInData.user && this.loggedInData.user.profile_image == null
                                  "
                                  class="style-scope yt-img-shadow"
                                  height="40"
                                  width="40"
                                  alt="image"
                                  src="../../assets/images/imag-27.jpg"
                                />
                                <!-- <img :src="`${getBlogUrl}/${getBlogDataById.author.profile_image}`" alt="image description"> -->
                                <div class="authorsinfo">
                                  <span class="bookwriter" v-if="getBlogDataById.author && getBlogDataById.author.name"
                                    >By:
                                    <a href="javascript:void(0);">{{
                                      getBlogDataById.author.name
                                    }}</a></span
                                  >
                                  <ul
                                    class="bg-postmetadata"
                                    style="padding-left: 0px !important"
                                  >
                                    <li>
                                      <a href="javascript:void(0);"
                                        ><i class="fas fa-comment"></i> &nbsp;
                                        {{ getBlogDataById.comments_count }}
                                        {{
                                          getBlogDataById.comments_count < 2
                                            ? "Comment"
                                            : "Comments"
                                        }}</a
                                      >
                                    </li>
                                    <!-- <li><a href="javascript:void(0);"><i class="fa fa-comment"></i><i>  {{getBlogDataById.reply_count}} Reply</i></a></li> -->
                                  </ul>
                                </div>
                              </figcaption>
                            </figure>
                          </div>
                          <div
                            class="
                              col-xs-12 col-sm-12 col-md-12 col-lg-12
                              pull-right
                            "
                          >
                            <div id="content" class="content">
                              <div class="newsdetail">
                                <div class="bg-posttitle mt-5">
                                  <h3>
                                    <a href="javascript:void(0);">{{
                                      getBlogDataById.title
                                    }}</a>
                                  </h3>
                                </div>
                                <div
                                  class="description"
                                  v-html="getBlogDataById.description"
                                ></div>
                              </div>
                            </div>
                          </div>
                          <template v-if="loggedInData.token != 'null'">
                            <form style="padding-left: 5px; !important ">
                              <img
                                v-if=" this.loggedInData.user &&
                                  this.loggedInData.user.profile_image != null
                                "
                                class="style-scope yt-img-shadow"
                                height="40"
                                width="40"
                                alt="image"
                                :src="`${getBlogUrl}/${this.loggedInData.user.profile_image}`"
                              />
                              <img
                                v-if=" this.loggedInData.user &&
                                  this.loggedInData.user.profile_image == null
                                "
                                class="style-scope yt-img-shadow"
                                height="40"
                                width="40"
                                alt="image"
                                src="../../assets/images/imag-27.jpg"
                              />
                              <input
                                v-model="blogComment.body"
                                type="text"
                                name="name"
                                class="
                                  form-control
                                  border-bottom border_comment
                                "
                                placeholder="Add your Comment"
                              />
                            </form>
                            <div class="float-right m-3">
                              <button
                                type="button"
                                class="btn btn-light"
                                @click="
                                  () => {
                                    this.blogComment.body = '';
                                  }
                                "
                              >
                                Cancel
                              </button>
                              <button
                                type="button"
                                class="btn btn-success"
                                @click="postBlogComment()"
                              >
                                COMMENT
                              </button>
                            </div>
                          </template>
                          <div
                            v-if="loggedInData.token == 'null'"
                            style="color: red; font-weight: bolder"
                          >
                            You need to login first to share your thoughts
                          </div>
                          <commentReply
                            :getContentDetailsPublic="getBlogDataById"
                            :loggedInData="loggedInData"
                            @reloadContent="reloadContent"
                          ></commentReply>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <RightSlider />
              </div>
            </div>
          </div>
          <div class="st-shape2">
            <img src="../../assets/images/contact-shape1.svg" alt="shape2" />
          </div>
        </section>
        <!--************************************
                    DGME links Start
                *************************************-->
      </main>
      <!--************************************
                    Main End
            *************************************-->
      <WebPortalFooter />
    </div>
  </div>
</template>

<script>
import WebPortalHeader from "../../components/webPortalLayout/WebPortalHeader.vue";
import LeftSlider from "../../components/webPortalLayout/LeftSlider";
import RightSlider from "../../components/webPortalLayout/RightSlider";
import WebPortalFooter from "../../components/webPortalLayout/WebPortalFooter";
import { baseURL2 } from "@/store/api.js";
import commentReply from "../../components/webPortalLayout/WebPortaBloglCommentReply.vue";
// import commentReply from "../../components/webPortalLayout/WebPortalBlogCommentReply.vue";

export default {
  name: "BlogDetails",
  components: {
    WebPortalHeader,
    LeftSlider,
    RightSlider,
    WebPortalFooter,
    commentReply,
  },
  data() {
    return {
      blogComment: {
        blog_id: null,
        body: "",
      },
      urldata: null,
      loggedInData: {
        user: null,
        token: null,
      },

      showReply: { value: null, state: false },
    };
  },
  created() {
    this.loggedInData.user = JSON.parse(
      window.localStorage.getItem("currentUser")
    );
    this.loggedInData.token = window.localStorage.getItem("dgmeToken");
    this.$store.dispatch("callHeaderFooterPublicData");
  },
  watch: {},
  computed: {
    getBlogDataById() {
      let tempData = this.$store.getters.getBlogDataById;
      this.blogComment.blog_id = tempData.id;
      return tempData;
    },
    getDataForChange() {
      return this.$store.getters.getPortalCommentReplyConflictData;
    },
    getBlogUrl() {
      // return `${baseURL2}/${this.getContentDetailsPublicData.content_url}`;
      return baseURL2;
    },
    loggedInPic(){
      return this.loggedInData.user.profile_image==null ? false : true;
    }
  },
  mounted() {
    this.urldata = this.$route.params.id;
    this.$store.dispatch("getBlogDetailsById", this.urldata);
   //  console.log("urldata", this.urldata);
    this.$store.commit("SET_PORTAL_COMMENT_REPLY_CONFLICT_DATA", this.urldata);
  },
  methods: {
    async reloadContent() {
      let data = this.getDataForChange;
      this.$store.dispatch("getBlogDetailsById", data);
    },
    showCommentReply(data) {
      this.showReply.value = data;
      this.showReply.state = true;
    },
    async postBlogComment() {
      await this.$store.dispatch("addBlogComment", this.blogComment);
      this.blogComment.body = "";
      this.$store.dispatch("getBlogDetailsById", this.urldata);
    },
    clearCommentReply() {
      this.commentReply.body = "";
      this.showReply.value = null;
      this.showReply.state = false;
    },
    async postCommentReply() {
      this.commentReply.comment_id = this.showReply.value;
      this.$store
        .dispatch("addBlogReply", this.commentReply)
        .then((response) => {
          if (response) {
          }
        })
        .catch((error) => {
          return error;
        });
    },
    changeShowAll() {
      this.showAllVar = this.getBlogDetailsPublicData.comments_count;
      ////  console.log("kisl", this.showAllVar);
    },
  },
};
</script>

<style scoped>
.row {
  display: block;
  flex-wrap: wrap;
  flex: 1 1 auto;
}
</style>
